/*
 * vendor_registrations.js — esbuild IIFE entry
 * Migrated from app/assets/javascripts/vendor_registrations.js
 * Provides WorkplaceVendorRegistrations for vendor/registrations index & workplace.
 */
import 'selectize';

const AgGridPagination = require('./modules/v4/components/ag_grid_pagination');
const URI = require('urijs');
require('./modules/search/vendor_registrations');   // registers window.VendorRegistrations
